var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rounded-full whitespace-no-wrap",class:_vm.classes()},[(_vm.loading)?_c('div',{staticClass:"lds-ellipsis"},[_c('div',{staticClass:"bg-gray-400"}),_c('div',{staticClass:"bg-gray-400"}),_c('div',{staticClass:"bg-gray-400"})]):_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }